import { useEffect } from "react";
import i18n, { LANGUAGE_STORAGE_KEY } from "@/core/i18n/config";
import { authSession } from "@/core/api/authSession";
import { useGetUserSettingsQuery } from "@/features/user-settings/infrastructure/api/userSettingsApi";

/**
 * Applies the signed-in user's saved web_language to i18next.
 *
 * Runs at the app root (not just inside the private Layout) so the check
 * against the API fires as soon as a session exists — e.g. right after a
 * fresh login, or when a still-valid session is detected on `/login` after
 * a logout — rather than only once the private area has mounted. The
 * request itself is skipped while logged out, since the endpoint requires
 * an access token; in that case the app keeps showing the last-synced
 * language already cached in localStorage.
 */
export const useLanguageSync = () => {
  const isAuthenticated = authSession.isAuthenticated();
  const { data: settings } = useGetUserSettingsQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    const code = settings?.webLanguage?.code;
    if (!code || code === i18n.language) return;

    void i18n.changeLanguage(code);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  }, [settings?.webLanguage?.code]);
};
